import { render, staticRenderFns } from "./BenevolentBank.vue?vue&type=template&id=d902ea44"
import script from "./BenevolentBank.vue?vue&type=script&lang=js"
export * from "./BenevolentBank.vue?vue&type=script&lang=js"
import style0 from "./BenevolentBank.vue?vue&type=style&index=0&id=d902ea44&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports